export default __webpack_public_path__ + "static/media/December2009.d8122419.png";